import React from "react";
import { Container, Box, Paper, Typography, Divider } from "@mui/material";
import BreadCrumbs from "../components/Breadcrumbs";

const LegalPage = () => {
    return (
        <Container maxWidth="xl" sx={{ mt: 3, mb: 5 }}>
            {/* Breadcrumbs */}
            <Box sx={{ mb: 3 }}>
                <BreadCrumbs hrefs="" name="Юридическая информация" />
            </Box>

            {/* Header */}
            <Paper sx={{ p: 3 }}>
                <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
                    scraplands.ru — Юридическая информация
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Здесь размещены официальные документы, регулирующие использование сайта, услуги и правила.
                </Typography>
                <Divider sx={{ my: 3 }} />

                {/* Раздел 1: Оферта */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" fontWeight={500} sx={{ mb: 1 }}>
                        Раздел 1. Оферта
                    </Typography>
                    <Typography variant="body2" paragraph>
                        1.1. Данный сайт и его услуги предоставляются пользователям на условиях настоящей публичной оферты.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        1.2. Используя сайт scraplands.ru, пользователь автоматически принимает условия оферты.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        1.3. Все спорные ситуации решаются в соответствии с действующим законодательством РФ.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        1.4. Все претензии можно направлять на электронную почту <b>support@scraplands.ru</b>.
                    </Typography>
                </Box>

                <Divider sx={{ mb: 3 }} />

                {/* Раздел 2: Политика конфиденциальности */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" fontWeight={500} sx={{ mb: 1 }}>
                        Раздел 2. Политика конфиденциальности
                    </Typography>
                    <Typography variant="body2" paragraph>
                        2.1. Сайт scraplands.ru собирает и обрабатывает персональные данные пользователей в рамках предоставления услуг.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        2.2. Пользователь соглашается на обработку данных при регистрации или использовании сайта.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        2.3. Все данные хранятся с использованием современных методов защиты и не передаются третьим лицам без согласия пользователя.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        2.4. Пользователь имеет право на доступ, изменение и удаление своих данных, обратившись на <b>support@scraplands.ru</b>.
                    </Typography>
                </Box>

                <Divider sx={{ mb: 3 }} />

                {/* Раздел 3: Общие положения */}
                <Box>
                    <Typography variant="h6" fontWeight={500} sx={{ mb: 1 }}>
                        Раздел 3. Общие положения
                    </Typography>
                    <Typography variant="body2" paragraph>
                        3.1. Сайт scraplands.ru оставляет за собой право вносить изменения в оферту и политику конфиденциальности без предварительного уведомления.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        3.2. Новая редакция вступает в силу с момента публикации на сайте.
                    </Typography>
                    <Typography variant="body2" paragraph>
                        3.3. Пользователь обязан самостоятельно отслеживать изменения документа.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default LegalPage;
